<template>
        <div>
           <el-form ref="form" :model="form" label-width="80px" class="form">
                <el-form-item  label="酒店名称:">
                    <el-input class="elInput" v-model="form.hotelName"></el-input>
                </el-form-item>
                <el-form-item label="电话:">
                    <el-input class="elInput"  v-model="form.tel"></el-input>
                </el-form-item>
                <el-form-item label="手机:">
                    <el-input class="elInput"  v-model="form.phome"></el-input>
                </el-form-item>
                <el-form-item label="联系人:">
                    <el-input class="elInput"  v-model="form.userName"></el-input>
                </el-form-item>
                <el-form-item label="酒店地址:">
                    <el-cascader class="hotelAddress" v-model="value" :options="options" @change="handleChange"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址:">
                     <el-input class="addressInfo" type="textarea" :rows="2" placeholder="请输入内容"  v-model="textarea"></el-input>
                </el-form-item>
                <el-form-item label="酒店等级:">
                    <el-select v-model="value" placeholder="请选择等级">
                      <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"  ></el-option>
                    </el-select>
                    客房总数:
                    <el-input-number v-model="num" @change="handleChange" :min="1" :max="10" label="描述文字" class="hotelStart"></el-input-number>
                </el-form-item>
                <el-form-item label="开业时间:">
                    <el-date-picker v-model="value1"  type="date" placeholder="选择日期"></el-date-picker>
                    装修时间:
                    <el-date-picker v-model="value1"  type="date" placeholder="选择日期" class="hotelDay"></el-date-picker>
                </el-form-item>
                <el-form-item label="酒店图片:">
                    <el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" class="hotelImg"><i class="el-icon-plus"></i></el-upload>
                    <el-dialog :visible.sync="dialogVisible"> <img width="100%" :src="dialogImageUrl" alt=""> </el-dialog>
                </el-form-item>
                <el-form-item label="酒店主题:">
                    <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">{{tag}}</el-tag>
                    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
                    <el-button v-else class="button-new-tag hotelLabel" size="small" @click="showInput">+添加</el-button>
                </el-form-item>
                <el-form-item label="酒店简介:">
                     <el-input type="textarea" :rows="5" placeholder="请输入内容、字数限制500字内..."  v-model="textarea"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                    <el-button>取消</el-button>
                </el-form-item>
            </el-form>
        </div>    
</template>

<script>
export default {
    data() {
      return {
        form: {
          hotelName: '',
          tel: '',
          phome: '',
          userName: ''
        },
        textarea: '',
        num: 1,
        value1: '',
        dialogImageUrl: '',
        dialogVisible: false,
        dynamicTags: ['亲子酒店', '浪漫情侣', '快速入住'],
        inputVisible: false,
        inputValue: ''
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      },
      handleChange(value) {
        console.log(value);
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
        }
        this.inputVisible = false;
        this.inputValue = '';
      }
    }
}
</script>

<style scoped>

.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  /* .elInputA{
    width: 20%;
    margin-right: 80%;
    margin-top: 2%;
  } */
  .elInput{
    width: 20%;
    margin-right: 80%;
  }

  .hotelAddress{
    margin-right: 90%;
  }

  .addressInfo{
    width: 50%;
    margin-right: 50%;
  }

  .hotelStart{
    margin-right: 70%;
  }

  .hotelDay{
    margin-right: 67%;
  }

  .hotelImg{
    margin-right: 90%;
  }

  .hotelLabel{
    margin-right: 77%;
  }

  .form{
    padding-top: 1%;
    padding-bottom: 1%;
  }


</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/setup/hotelInfo.vue